import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetModuleSubscriptionsAction implements Action {
  public static readonly type = 'GetModuleSubscriptionsAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetModuleSubscriptionsAction.type;
}
